const translations = {
  translation: {
    appTitle: '单位转换器',
    appDescription: '在11个不同类别中即时转换单位',
    selectCategory: '选择类别',
    categories: {
      length: '长度',
      mass: '质量',
      force: '力',
      energy: '能量',
      power: '功率',
      pressure: '压力',
      temperature: '温度',
      time: '时间',
      volume: '体积',
      angle: '角度',
      area: '面积',
    },
    units: {
      meter: '米',
      kilometer: '千米',
      centimeter: '厘米',
      millimeter: '毫米',
      micrometer: '微米',
      nanometer: '纳米',
      mile: '英里',
      yard: '码',
      foot: '英尺',
      inch: '英寸',
      nauticalMile: '海里',
      kilogram: '千克',
      gram: '克',
      milligram: '毫克',
      metricTon: '公吨',
      pound: '磅',
      ounce: '盎司',
      ton: '美吨',
      stone: '英石',
      newton: '牛顿',
      kilonewton: '千牛',
      poundForce: '磅力',
      kilopoundForce: '千磅力',
      dyne: '达因',
      joule: '焦耳',
      kilojoule: '千焦',
      calorie: '卡路里',
      kilocalorie: '千卡',
      wattHour: '瓦时',
      kilowattHour: '千瓦时',
      electronvolt: '电子伏特',
      btu: '英热单位',
      footPound: '英尺磅',
      watt: '瓦特',
      kilowatt: '千瓦',
      megawatt: '兆瓦',
      horsepower: '马力',
      btuPerHour: '英热单位/小时',
      pascal: '帕斯卡',
      kilopascal: '千帕',
      bar: '巴',
      atmosphere: '标准大气压',
      psi: '磅/平方英寸',
      torr: '托',
      mmHg: '毫米汞柱',
      celsius: '摄氏度',
      fahrenheit: '华氏度',
      kelvin: '开尔文',
      second: '秒',
      millisecond: '毫秒',
      microsecond: '微秒',
      nanosecond: '纳秒',
      minute: '分钟',
      hour: '小时',
      day: '天',
      week: '周',
      month: '月',
      year: '年',
      liter: '升',
      milliliter: '毫升',
      cubicMeter: '立方米',
      cubicCentimeter: '立方厘米',
      gallon: '加仑',
      quart: '夸脱',
      pint: '品脱',
      cup: '杯',
      fluidOunce: '液量盎司',
      tablespoon: '汤匙',
      teaspoon: '茶匙',
      degree: '度',
      radian: '弧度',
      gradian: '百分度',
      arcminute: '分',
      arcsecond: '秒',
      turn: '圈',
      squareMeter: '平方米',
      squareKilometer: '平方千米',
      squareCentimeter: '平方厘米',
      squareMillimeter: '平方毫米',
      hectare: '公顷',
      acre: '英亩',
      squareMile: '平方英里',
      squareYard: '平方码',
      squareFoot: '平方英尺',
      squareInch: '平方英寸',
    },
    from: '从',
    to: '到',
    enterValue: '输入值',
    result: '结果',
  },
};

export default translations;
